(function () {
  var WIDGET_SEL = 'essential-estimated-delivery-widget, .essential-estimated-delivery-widget';
  var STYLE_ID  = 'delivery-accordion-style';

  function buildAccordion(widget) {
    if (widget.closest('.delivery-info-accordion')) return;

    var acc = document.createElement('accordion-custom');

    var details = document.createElement('details');
    details.className = 'details delivery-info-accordion';

    var summary = document.createElement('summary');
    summary.className = 'details__header delivery-info-summary';
    summary.innerHTML =
      'Shipping Info' +
      '<span class="svg-wrapper icon-caret icon-animated">' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
      '</span>';

    var content = document.createElement('div');
    content.className = 'details-content';

    widget.parentNode.insertBefore(acc, widget);
    content.appendChild(widget);
    details.appendChild(summary);
    details.appendChild(content);
    acc.appendChild(details);

    if (!document.getElementById(STYLE_ID)) {
      var s = document.createElement('style');
      s.id = STYLE_ID;
      s.textContent =
        '.delivery-info-accordion{border-top:1px solid rgb(var(--color-foreground-rgb)/.15);border-bottom:1px solid rgb(var(--color-foreground-rgb)/.15);margin-block:4px;}' +
        '.delivery-info-summary{font-weight:600;}';
      document.head.appendChild(s);
    }
  }

  function tryWrap() {
    var widget = document.querySelector(WIDGET_SEL);
    if (widget) buildAccordion(widget);
  }

  tryWrap();
  new MutationObserver(tryWrap).observe(document.body, { childList: true, subtree: true });
})();